import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '../../../redux/hooks';
import MigrationRenewalDialog from './MigrationRenewalDialog';
import { STAY_ON_FREE_STORAGE_PREFIX, useMigrationRenewal } from './useMigrationRenewal';

const SESSION_KEY = 'migration-renewal-shown';

const EXCLUDED_PATH_PREFIXES = ['/plans', '/chats', '/reservations'];

const isExcludedPath = (pathname: string) =>
  EXCLUDED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

const MigrationRenewalGate: React.FC = () => {
  const location = useLocation();
  const state = useMigrationRenewal();
  const venueId = useAppSelector((s) => s.venue.value?.id);

  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!state.needsMigrationRenewal) return;
    if (sessionStorage.getItem(SESSION_KEY) === '1') return;
    // Venues can opt out persistently via the "Stay on Free" action.
    if (
      venueId != null &&
      localStorage.getItem(`${STAY_ON_FREE_STORAGE_PREFIX}${venueId}`) === '1'
    ) {
      return;
    }
    if (isExcludedPath(location.pathname)) return;

    setOpen(true);
  }, [state.needsMigrationRenewal, location.pathname, venueId]);

  const handleClose = React.useCallback(() => {
    setOpen(false);
    sessionStorage.setItem(SESSION_KEY, '1');
  }, []);

  if (!state.needsMigrationRenewal) return null;

  return <MigrationRenewalDialog open={open} onClose={handleClose} state={state} />;
};

export default MigrationRenewalGate;
